module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (111).509467c8.jpg";